import toast from 'cogo-toast'
import Cookies from 'js-cookie'
import { API_ENDPOINT } from '../env'
import { version } from '../../package.json'
import store from './store'

export default class Request {
  static async post(fn, payload, customHeaders) {
    const defaultHeaders = {
      credentials: 'include',
      'Content-Type': 'application/json',
      'x-malus-app': 'dashboard',
      'x-malus-version': version,
      'x-malus-lang': store ? store.lang.id : 'en'
    }
    const loginInfo = window.localStorage.getItem('login')
    const token = Cookies.get('malus-token')
    if (token) {
      defaultHeaders['x-malus-token'] = token
    }
    if (loginInfo) {
      try {
        defaultHeaders['x-malus-token'] = JSON.parse(loginInfo).token
      } catch (err) {
        // eslint-disable-next-line
        console.warn(
          `WARN Unexpected end of JSON input please check localstorage.login`,
        )
      }
    }
    const headers = customHeaders
      ? { ...defaultHeaders, ...customHeaders }
      : defaultHeaders
    let body = '{}'
    if (payload) {
      if (typeof payload !== 'object') {
        // eslint-disable-next-line
        console.warn(
          `WARN Request.${fn} input payload must be a Object but incoming ${payload}`,
        )
      }
      body = JSON.stringify(payload)
    }
    let json = {}
    try {
      // console.log('Request.post', `${API_ENDPOINT}/${fn}`, headers, body)
      const response = await fetch(`${API_ENDPOINT}/${fn}`, {
        method: 'POST',
        headers,
        body,
      })
      if (response.status !== 200) {
        throw new Error(response.statusText)
      }
      json = await response.json()
    } catch (err) {
      json = {
        code: 1,
        message: err.message || `${fn} Unexpected end of JSON input`,
      }
    }
    if (json.code === 11138) {
      return json
    }
    if (json.code === 10001) {
      window.localStorage.setItem('login', null)
      Cookies.remove('malus-token', {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      })
      window.location.href = '/dashboard/login'
      return false
    }
    if (json.code !== 0) {
      const message = json.message
        ? `${json.message}`
        : `Exception Api[${fn}] call error`
      toast.error(message)
      return false
    }
    return json.data ? json.data : true
  }

  static call(fn, payload) {
    return Request.post(fn, payload)
  }
}
